"use client";

import { PortableText } from "next-sanity";
import { richTextComponent } from "@/sanity/sanityPortableText";
import { CTAButton } from "@/shadcn/ui/button";
import ScrollingBanner from "@/components/pageComponents/global/ScrollingBanner";
import { PageFuturesLPSchema } from "@/sanity/pages/PageFuturesLPTemplate";

export default function RulesSection({ data }: { data: PageFuturesLPSchema }) {
  return (
    <section className="bg-white relative overflow-hidden pb-[10rem] lg:pb-[20rem]">
      {/* Content column */}
      <div className="mx-auto w-[min(78.125rem,100%)] px-[3rem] lg:px-0 flex flex-col gap-[4.5rem] items-center ">
        {/* Header text */}
        <div className="relative flex flex-col gap-[2rem] items-center text-center w-full">
          {data.pricingChip && (
            <p className="mb-0 font-blacker italic text-[2rem] leading-[1.5] text-black">
              {data.pricingChip}
            </p>
          )}

          {data.pricingTitle && (
            <div className="richtext richtext-center flex flex-col gap-0 prose-h2:text-[5rem] lg:prose-h2:text-[7rem] prose-h2:tracking-[-0.21rem] prose-h2:leading-none prose-h2:mb-[2rem] max-sm:prose-p:[text-wrap-style:balance]">
              <PortableText
                value={data.pricingTitle}
                components={richTextComponent}
              />
            </div>
          )}
        </div>

        {/* Rules table */}
        {!!data.pricingRows?.length && (
          <div className="w-full flex flex-col gap-[0.5rem] lg:max-w-[64.5rem]">
            {data.pricingRows.map((row, i) => (
              <div
                key={row._key ?? i}
                className={`flex gap-[1rem] items-center px-[2rem] py-[1.5rem] ${
                  i % 2 === 0 ? "bg-[#f7f7f7]" : "bg-white"
                }`}
              >
                <p className="mb-0 flex-1 font-geist font-medium text-[2rem] lg:text-[2.25rem] leading-[1.5] text-black/50 uppercase">
                  {row.label}
                </p>
                <p className="mb-0 w-[19.5rem] shrink-0 font-geist font-medium text-[2.25rem] lg:text-[2.5rem] leading-[1.5] text-black/80">
                  {row.value}
                </p>
              </div>
            ))}
          </div>
        )}

        {/* CTA block */}
        <div className="flex flex-col gap-[1.5rem] items-center w-full">
          {data.pricingCTA && (
            <CTAButton
              data={data.pricingCTA}
              className="w-full lg:w-[40.875rem] rounded-[0.25rem]"
            />
          )}
          {data.pricingSubtext && (
            <p className="mb-0 font-geist font-normal text-[2.25rem] leading-[1.5] text-black/70 text-center">
              {data.pricingSubtext}
            </p>
          )}
        </div>
      </div>
    </section>
  );
}
